import SectionTitle from "./SectionTitle";

const STEPS = [
  {
    icon: "ri-eye-2-line",
    title: "先看画面",
    desc: "回到现场视频与实拍原片本身，注意镜头裁剪、时间戳与光线是否一致，别被转述先带偏。",
  },
  {
    icon: "ri-node-tree",
    title: "再对线索",
    desc: "把目击者说、截图时间与发布链路并排比对，相符的记一笔，存疑的标出来，等补证再下判断。",
  },
  {
    icon: "ri-discuss-line",
    title: "听不同解",
    desc: "看别人如何解读同一处细节，分歧本身往往指向画面里被忽略的地方，回看原片最有效。",
  },
];

export default function MethodNote() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          index="06"
          kicker="关于 911网"
          title={<>判断真假这件事，这里只负责摆材料</>}
          lead="911网不替任何一方下结论。我们做的是把现场视频、实拍、图片流出与目击者说、截图线索归拢到同一页，尽量让每个人都能对着画面自己判断。下面是我们整理时习惯走的三步。"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {STEPS.map((s, i) => (
            <div key={s.title} className="relative overflow-hidden rounded-lg border border-foreground-200/70 bg-background-100 p-6 md:p-7">
              <span className="pointer-events-none absolute -right-2 -top-4 font-serif text-[80px] font-black leading-none text-foreground-100">
                {i + 1}
              </span>
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${s.icon} text-lg`} aria-hidden="true" />
              </span>
              <h3 className="mt-5 font-serif text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-500">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-lg border border-dashed border-foreground-300 bg-background-100/50 px-6 py-5 md:flex-row md:items-center">
          <p className="text-[13px] leading-6 text-foreground-500">
            材料以现场视频、实拍与流出图片为主，附目击者说与截图线索作旁证。若标注有误或先后判断需要更正，我们会在对应档案上补更，并保留改动痕迹。
          </p>
          <a href="#top" className="inline-flex shrink-0 items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap">
            <i className="ri-arrow-up-line text-[15px]" aria-hidden="true" />返回顶部
          </a>
        </div>
      </div>
    </section>
  );
}